import {
    Form,
    FormField,
    FormSection,
    FormType
} from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';

import { TratamientoManezModel } from 'src/app/models/tratamientos/tratatamiento-manez.model';

export class TrataManezFormDefinition {

    public formFields: Form<TratamientoManezModel>;

    public constructor(
        private readonly formType: FormType,
        private readonly model: TratamientoManezModel,
        private readonly unidad: string
    ) {
        this.formFields = {
            name: 'tratamientos-manez',
            header: this.getHeader(),
            type: this.formType,
            sections: this.getFormSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: ''
            },
            signed: false
        };
    }

    private getHeader(): string {
        switch (this.formType) {
            case FormType.DELETION:
                return 'Eliminar Tratamiento';
            case FormType.INFORMATIVE:
                return 'Detalle del Tratamiento';
            default:
                return 'Tratamiento';
        }
    }

    private getFormSections(): FormSection<TratamientoManezModel>[] {
        return [
            {
                name: 'Datos generales',
                fields: this.getGeneralFields(),
                width: 12,
                isVisible: true,
                order: 1
            }
        ];
    }

    private getGeneralFields(): FormField<TratamientoManezModel>[] {
        return [
            this.createReadonlyField('n_tratamiento', 'Nº Tratamiento', 1),
            this.createReadonlyField('nombre', 'Nombre', 2),
            this.createReadonlyField('maquinaria_nombre', 'Maquinaria', 3),
            this.createReadonlyField('campo_nombre', 'Campo', 4),
            this.createReadonlyField('ancho_calle', 'Ancho de calle', 5),
            this.createReadonlyField('fecha_formatted', 'Fecha Receta', 6),
            this.createReadonlyField('hora_inicio', 'Hora Inicio', 7),
            this.createReadonlyField('hora_fin', 'Hora Fin', 8),
            this.createReadonlyField('litros', 'Litros/' + this.unidad, 9),
            this.createReadonlyField('marcha', 'Velocidad de avance (km/h)', 10),
            this.createReadonlyField('rpm', 'RPM', 11),
            this.createReadonlyField('presion', 'Presión', 12),
            this.createReadonlyField('caudal', 'Caudal (l/min)', 13),
            this.createReadonlyField('modo_trabajo', 'Modo trabajo', 14),
            this.createReadonlyField('regulacion_dosis', 'Regulación dosis', 15),
            this.createReadonlyField('estado_tratamiento', 'Estado tratamiento', 16),
            this.createReadonlyField('boquilla_nombre', 'Boquilla', 17)
        ];
    }

    private createReadonlyField(
        name: string,
        label: string,
        order: number
    ): FormField<TratamientoManezModel> {
        return {
            name,
            vinculatedFields: undefined,
            label,
            input: {
                type: InputType.ONLY_TEXT,
                isEditable: false,
                defaultValue: this.getDisplayValue(name)
            },
            width: 4,
            conditions: {
                isRememberedOnDuplicate: false,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true
            },
            order
        };
    }

    private getDisplayValue(name: string): string | number | Date | null {
        const value = this.model[name];

        if (value == null) {
            return null;
        }

        if (typeof value === 'string' || typeof value === 'number' || value instanceof Date) {
            return value;
        }

        return String(value);
    }
}
